import { BannerSeverity } from "../../interfaces/banner.interface";

export function bannerSeverityMeta(severity: BannerSeverity): {
  label: string;
  color: string;
} {
  switch (severity) {
    case BannerSeverity.Info:
      return { label: "Info", color: "blue" };
    case BannerSeverity.Warning:
      return { label: "Warning", color: "gold" };
    case BannerSeverity.Error:
      return { label: "Error", color: "red" };
    default:
      return { label: severity, color: "default" };
  }
}
